/**
 * @generated SignedSource<<d2ed932e6b2aa371764c58e3ff8fa09b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type diligenceKpiCellPanel_Query$variables = {
  band?: string | null | undefined;
  basis?: string | null | undefined;
  dimension?: string | null | undefined;
  limit?: number | null | undefined;
  metric: string;
  month: string;
  offset?: number | null | undefined;
};
export type diligenceKpiCellPanel_Query$data = {
  readonly diligenceCell: {
    readonly basis: string;
    readonly columns: ReadonlyArray<{
      readonly align: string | null | undefined;
      readonly format: string;
      readonly key: string;
      readonly label: string;
    }>;
    readonly components: ReadonlyArray<{
      readonly basis: string | null | undefined;
      readonly format: string;
      readonly label: string;
      readonly metric: string | null | undefined;
      readonly month: string | null | undefined;
      readonly value: number | null | undefined;
    }>;
    readonly derivation: {
      readonly formula: string;
      readonly operands: ReadonlyArray<{
        readonly basis: string | null | undefined;
        readonly format: string;
        readonly label: string;
        readonly metric: string | null | undefined;
        readonly month: string | null | undefined;
        readonly value: number | null | undefined;
      }>;
      readonly result: number | null | undefined;
      readonly undefined: boolean;
    } | null | undefined;
    readonly format: string;
    readonly formula: string;
    readonly label: string;
    readonly limit: number;
    readonly methodology: ReadonlyArray<{
      readonly label: string;
      readonly text: string;
    }>;
    readonly metric: string;
    readonly month: string;
    readonly notSegmentable: {
      readonly reason: string;
      readonly supportedDimensions: ReadonlyArray<string>;
    } | null | undefined;
    readonly note: string | null | undefined;
    readonly offset: number;
    readonly rows: ReadonlyArray<{
      readonly cells: ReadonlyArray<{
        readonly number: number | null | undefined;
        readonly text: string | null | undefined;
      }>;
      readonly pseudonym: string | null | undefined;
    }>;
    readonly totalCount: number;
    readonly totals: ReadonlyArray<{
      readonly number: number | null | undefined;
      readonly text: string | null | undefined;
    }>;
    readonly value: number | null | undefined;
    readonly windowFrom: string;
    readonly windowTo: string;
  };
};
export type diligenceKpiCellPanel_Query = {
  response: diligenceKpiCellPanel_Query$data;
  variables: diligenceKpiCellPanel_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "band"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "basis"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dimension"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "limit"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "metric"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "month"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offset"
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "metric",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "format",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "basis",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "month",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formula",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v14 = [
  (v8/*: any*/),
  (v13/*: any*/),
  (v9/*: any*/),
  (v7/*: any*/),
  (v11/*: any*/),
  (v10/*: any*/)
],
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v16 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "number",
    "storageKey": null
  },
  (v15/*: any*/)
],
v17 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "band",
        "variableName": "band"
      },
      {
        "kind": "Variable",
        "name": "basis",
        "variableName": "basis"
      },
      {
        "kind": "Variable",
        "name": "dimension",
        "variableName": "dimension"
      },
      {
        "kind": "Variable",
        "name": "limit",
        "variableName": "limit"
      },
      {
        "kind": "Variable",
        "name": "metric",
        "variableName": "metric"
      },
      {
        "kind": "Variable",
        "name": "month",
        "variableName": "month"
      },
      {
        "kind": "Variable",
        "name": "offset",
        "variableName": "offset"
      }
    ],
    "concreteType": "DiligenceCell",
    "kind": "LinkedField",
    "name": "diligenceCell",
    "plural": false,
    "selections": [
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "windowFrom",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "windowTo",
        "storageKey": null
      },
      (v12/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "note",
        "storageKey": null
      },
      (v13/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "limit",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "offset",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DiligenceCellComponent",
        "kind": "LinkedField",
        "name": "components",
        "plural": true,
        "selections": (v14/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DiligenceCellDerivation",
        "kind": "LinkedField",
        "name": "derivation",
        "plural": false,
        "selections": [
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "result",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "undefined",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DiligenceCellComponent",
            "kind": "LinkedField",
            "name": "operands",
            "plural": true,
            "selections": (v14/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DiligenceMethodologyEntry",
        "kind": "LinkedField",
        "name": "methodology",
        "plural": true,
        "selections": [
          (v8/*: any*/),
          (v15/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DiligenceNotSegmentable",
        "kind": "LinkedField",
        "name": "notSegmentable",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "reason",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "supportedDimensions",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DiligenceCellColumn",
        "kind": "LinkedField",
        "name": "columns",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "key",
            "storageKey": null
          },
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "align",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DiligenceCellRow",
        "kind": "LinkedField",
        "name": "rows",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pseudonym",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DiligenceCellValue",
            "kind": "LinkedField",
            "name": "cells",
            "plural": true,
            "selections": (v16/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DiligenceCellValue",
        "kind": "LinkedField",
        "name": "totals",
        "plural": true,
        "selections": (v16/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "diligenceKpiCellPanel_Query",
    "selections": (v17/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v5/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Operation",
    "name": "diligenceKpiCellPanel_Query",
    "selections": (v17/*: any*/)
  },
  "params": {
    "cacheID": "11035f4511567d48b7c40b4cdba6f252",
    "id": null,
    "metadata": {},
    "name": "diligenceKpiCellPanel_Query",
    "operationKind": "query",
    "text": "query diligenceKpiCellPanel_Query(\n  $metric: String!\n  $month: String!\n  $basis: String\n  $dimension: String\n  $band: String\n  $limit: Int\n  $offset: Int\n) {\n  diligenceCell(metric: $metric, month: $month, basis: $basis, dimension: $dimension, band: $band, limit: $limit, offset: $offset) {\n    metric\n    label\n    format\n    basis\n    month\n    windowFrom\n    windowTo\n    formula\n    note\n    value\n    totalCount\n    limit\n    offset\n    components {\n      label\n      value\n      format\n      metric\n      month\n      basis\n    }\n    derivation {\n      formula\n      result\n      undefined\n      operands {\n        label\n        value\n        format\n        metric\n        month\n        basis\n      }\n    }\n    methodology {\n      label\n      text\n    }\n    notSegmentable {\n      reason\n      supportedDimensions\n    }\n    columns {\n      key\n      label\n      format\n      align\n    }\n    rows {\n      pseudonym\n      cells {\n        number\n        text\n      }\n    }\n    totals {\n      number\n      text\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e33314115d4aaa9781c2bc2e5eaea6e6";

export default node;
